// Component: src/theme/snippets/table.liquid

document.querySelectorAll(".snippet-table").forEach((snippet) => {
  const data = window.metaobjectTables?.find((t) => t.handle === snippet.dataset.tableHandle);
  if (!data) return;

  const { title, rows } = data;

  const $title = snippet.querySelector(".table-title");
  const $tbody = snippet.querySelector("table tbody");

  if (title && $title) {
    $title.innerText = title;
  } else {
    $title?.classList.add("hidden");
  }

  if (!$tbody || !rows?.length) return;

  rows.forEach((row) => {
    const $tr = document.createElement("tr");
    row.forEach((cell) => {
      const $td = document.createElement("td");
      $td.innerText = cell?.trim();
      $tr.appendChild($td);
    });
    $tbody.appendChild($tr);
  });
});
